import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter
} from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-password-security',
  templateUrl: './password-security.component.html',
  styleUrls: ['./password-security.component.scss'],
})
export class PasswordSecurityComponent implements OnInit, OnChanges {
  @Input() password: any;
  @Input() confirmPassword: any;
  @Output() OnValidSecurity: EventEmitter<number> = new EventEmitter();

  public listItems!: any;
  public baseurl = environment.baseUrl;
  public validSecurity: number = 0;

  ngOnInit(): void {
    this.setListItems();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password'] || changes['confirmPassword']) {
      let value = this.password;
      this.validSecurity = 0;
      this.setListItems();

      if (value !== '' && value !== null ) {
        this.setItemValue('uppercase',this.hasUppercase(value));
        this.setItemValue('lowercase',this.hasLowercase(value));
        this.setItemValue('number', this.hasNumber(value));
        this.setItemValue('special',this.hasSpecialCharacter(value));
        this.setItemValue('min', this.hasMinLength(value));
        this.setItemValue('max', this.hasMaxLength(value));
        this.setItemValue('equal',this.passwordsMatch(value));
      }
    }
  }

  private hasUppercase(value: string): 'success' | 'error' {
    return /[A-Z]/.test(value) ? 'success' : 'error';
  }

  private hasLowercase(value: string): 'success' | 'error' {
    return /[a-z]/.test(value) ? 'success' : 'error';
  }

  private hasNumber(value: string): 'success' | 'error' {
    return /\d/.test(value) ? 'success' : 'error';
  }

  private hasSpecialCharacter(value: string): 'success' | 'error' {
    return /[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`\\=+]/.test(value) ? 'success' : 'error';
  }

  private hasMinLength(value: string): 'success' | 'error' {
    return value?.length > 7 ? 'success' : 'error';
  }
  private hasMaxLength(value: string): 'success' | 'error' {
    return value?.length <= 20? 'success' : 'error';
  }
  private passwordsMatch(value: string): 'success' | 'error' {
    return value === this.confirmPassword ? 'success' : 'error';
  }

  setListItems() {
    this.listItems = [
      {
        id: 'min',
        status: 'valid',
        label: 'Debe tener un mínimo de 7 caracteres.',
      },
      {
        id: 'max',
        status: 'valid',
        label: 'Debe tener un máximo de 20 caracteres.',
      },
      {
        id: 'uppercase',
        status: 'valid',
        label: 'Debe tener al menos una mayúscula.',
      },
      {
        id: 'lowercase',
        status: 'valid',
        label: 'Debe tener al menos una minúscula.',
      },
      {
        id: 'number',
        status: 'valid',
        label: 'Debe tener al menos un número.',
      },
      {
        id: 'special',
        status: 'valid',
        label: 'Debe tener al menos un caracter especial.',
        tooltipText:
          '^ $ * . [ ] { } ( ) ? " ! @ # % & / \\ , > < \' : ; | _ ~ ` = + -',
      },
      {
        id: 'equal',
        status: 'valid',
        label: 'Ambas contraseñas deben coincidir.',
      },
    ];
  }

  setItemValue(id: string, status: string) {
    this.listItems.forEach((item: any) => {
      if (item.id === id) {
        this.validSecurity =
          status === 'success' ? this.validSecurity + 1 : this.validSecurity;
        item.status = status;
      }
    });

    this.OnValidSecurity.emit(this.validSecurity);
  }

  getImageStatus(status: string) {
    if (this.password === '') {
      return this.baseurl + '/assets/images/check-box-list.svg';
    }

    return {
      valid: this.baseurl + '/assets/images/check-box-list.svg',
      success: this.baseurl + '/assets/images/check-box-list-success.svg',
      error: this.baseurl + '/assets/images/check-box-list-error.svg',
    }[status];
  }
}
